export default "/images/d4ccccdd640f78b8cb6ecdf3451d5fd6.avif";